import { render, staticRenderFns } from "./AnythingllmRichEditor.vue?vue&type=template&id=3e98f890&scoped=true"
import script from "./AnythingllmRichEditor.vue?vue&type=script&lang=js"
export * from "./AnythingllmRichEditor.vue?vue&type=script&lang=js"
import style0 from "./AnythingllmRichEditor.vue?vue&type=style&index=0&id=3e98f890&prod&scoped=true&lang=css"
import style1 from "./AnythingllmRichEditor.vue?vue&type=style&index=1&id=3e98f890&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e98f890",
  null
  
)

export default component.exports